export const getGeneralChatSelector = state => state.generalChat;
